import React, { useEffect, useState } from 'react';
import { FilteringPage } from 'hse-filtering-library-frontend';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Page from '@constants/page';
import NavigationBreadcrumb from '@components/Navigation/Breadcrumb/NavigationBreadcrumb';
import FilteringEntityType from '@constants/filteringEntityType';
import i18n from '@src/i18n';
import CustomCellsDefinition, { ColumnName } from '../CustomCellsDefinition';

type RowValueType = {
  [key: string]: string;
};

export const customCellRenderer = ({
  rowValues,
  column,
}: {
  rowValues: RowValueType;
  column: any;
}) => {
  const { key } = column ?? {};
  const value = rowValues[key];
  const renderCustomCell = CustomCellsDefinition[key as ColumnName];
  if (renderCustomCell) {
    return renderCustomCell(rowValues);
  }
  return value;
};

function ElectricalActionSummaryDetails() {
  const [language, setLanguage] = useState(i18n.language);
  const { t } = useTranslation();
  const params = useParams();
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (language !== i18n.language) {
      setLanguage(i18n.language);
    }
  }, [language, t]);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh]);

  return (
    <div className={FilteringEntityType.ELECTRICAL_ACTION_SUMMARY}>
      <NavigationBreadcrumb currentPage={Page.ELECTRICAL_ACTION_SUMMARY} />
      <FilteringPage
          type={FilteringEntityType.ELECTRICAL_ACTION_SUMMARY}
          customCellRenderer={customCellRenderer}
          additionalArgs={{
            filters: { UPLOAD_ID: params.uploadId },
          }}
          defaultSort={[{ sortField: 'OBSERVATION_NUMBER', sortDirection: 'ASC' }]}
          wrapDetailsText
          lang={language}
          showAggregations={false}
          filtersCollapsed
          renderSorting
          showHeaderTooltips={false}
          noFavorites
          noHelpButton
          refreshPage={refresh}
      />
    </div>
  );
}

export default ElectricalActionSummaryDetails;
